import { StyleSheet } from "react-native"

export default StyleSheet.create({
  messageContent: {
    flex: 1,
  },
  buttonWrap: {
    flexDirection: "row",
  },
})
